import React from 'react';
import { Helmet } from 'react-helmet';
import { useProductTypeJsonSchemaForSeo } from 'component/page/detail/SEOLdJson/useSeoLdJsonData';

const SeoLdJson: React.FC = () => {
    const schema = useProductTypeJsonSchemaForSeo();
    if (schema.name === '' || schema.description === '' || schema.aggregateRating.ratingValue < 1 || schema.aggregateRating.reviewCount < 1) return null;
    const ldJson = JSON.stringify(schema);

    return (
        <Helmet>
            <script type="application/ld+json">{ldJson}</script>
        </Helmet>
    );
};
SeoLdJson.displayName = 'SeoLdJson';

export default SeoLdJson;
